export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-side-WEB-THUMB-d0ed80f3fe762930f7f1e56f2459a4d4.jpg";